// AUTO-GENERATED by scripts/inject-env-vars.js — DO NOT EDIT.
// Regenerated on every build via the `inject-env` Nx target (see project.json).
// Swapped in for environment.ts in the `production` build configuration.

import type { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  apiUrl: "https://indutrust-api-production.herokuapp.com/api/v1/",
  appEnv: "prd",
  googleMapsApiKey: "AIzaSyBLYOzVvyunDFE4I_OEHucZhkZqkSo2ipE",
  googleMapsMapId: "e66079a42a38b1ba",
  googleMapsMapIdDark: "e66079a42a38b1ba",
  posthogHost: "https://eu.i.posthog.com",
  posthogKey: "phc_zUgHzAizaWg3qMHewuCT29y946w7B9jJ2PsNkVHMuLgH",
  primeNgLicenseKey: "eyJpZCI6IjQzZjE3NzcxLThmOTYtNGRlYy1hNWNjLTk1MjI2NzQzZGE1OSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODg1OTY0OTcsImV4cCI6MTgyMDEzMjQ5N30.TM1B66tgqr4Td-vCrcJz0wLASOndqV_7rkue30EKDzgwsIyJ4fPcjHLRbU0x1ZzwtgSibN4XO_XiFT78BYSUDA",
};
